import { DataModel } from "common/models/utility-models/base-model";

export class MentorModel extends DataModel {
    mentorName: string = '';
    mentorEmail: string = '';
    mentorContact: string = '';
    mentorStateId: string = '';
    mentorGender: any = '';
    mentorCompany: number = null;
}